import { emailAddressRegex, phoneNumberRegex } from './regex'

type YupTestTypeArgs = [string, string, (field: string | undefined) => boolean]

export const notMatchingEmailMessage = 'Emails do not match'
export const invalidEmailMessage = 'Enter valid email address'
export const requiredPhoneNumberMessage = 'Phone number is required'

export const phoneNumberIsNumberTest: YupTestTypeArgs = [
  'isNumber',
  'Phone number must only use numbers 0-9 ',
  (phoneNumber: string | undefined) =>
    phoneNumber && !phoneNumberRegex.test(phoneNumber) ? false : true,
]

export const phoneNumberIsTenDigits: YupTestTypeArgs = [
  'isTenDigits',
  'Phone number must be 10 digits ',
  (phoneNumber: string | undefined) => phoneNumber && phoneNumber.length === 10,
]

export const noFiveFiveFiveAreaCodeTest: YupTestTypeArgs = [
  'isNot555',
  'Area code cannot be 555',
  (phoneNumber: string | undefined) =>
    phoneNumber && phoneNumber?.startsWith('555') ? false : true,
]

export const isValidEmailTest: YupTestTypeArgs = [
  'isValidEmail',
  'Enter valid email address',
  (email: string | undefined) =>
    !email ? true : email && emailAddressRegex.test(email) ? true : false,
]
